package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.doOnClick
import com.example.mystybag.common.extensions.modifyIf
import com.example.mystybag.common.model.IconData

@Composable
fun CircleIconView(modifier: Modifier = Modifier, model: IconData, onClick: (() -> Unit)? = null) {
    Box(
        contentAlignment    = Alignment.Center,
        modifier            = modifier
            .size(model.circleSize)
            .clip(CircleShape)
            .background(model.circleColor)
            .modifyIf(onClick != null) { doOnClick { onClick?.invoke() } }
    ) {
        Image(
            painter         = model.icon,
            modifier        = Modifier.size(model.iconSize),
            colorFilter     = ColorFilter.tint(model.iconColor),
            contentScale    = ContentScale.Fit
        )
    }
}